import { useSelector } from "react-redux";
import ContentModulesContainer from "components/source/shared/content-modules-container";

const BottomGridContent = () => {
  const gridFooterContent = useSelector(state => state?.gridFooterContent);

  return (
    <>
      {gridFooterContent?.contentModules?.length > 0 && (
        <ContentModulesContainer contentModules={gridFooterContent.contentModules} />
      )}
    </>
  );
};

export default BottomGridContent;
